<template>
  <el-row type="flex" class="tg-marquee" justify="start" align="start">
    <tg-marquee-icon></tg-marquee-icon>
    <marquee v-html="marquee" onmouseover="this.stop();" onmouseout="this.start();">{{ marquee}}</marquee>
  </el-row>
</template>

<script>
import TgMarqueeIcon from "@/components/marquee/TgMarqueeIcon";

export default {
  components: {
    TgMarqueeIcon
  },
  props: {
    marquee: String
  }
};
</script>